module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[12]255.de51366.woff2";